//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Default from '~/components/templets/default';
import Primary from '~/components/templets/primary';

import axios from 'axios';

export default {
    name: "step1",
    components: {
        default: Default,
        primary: Primary
    },
    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        }
    },
    data: function data() {
        return {
            loading: true,
            packages: []
        };
    },
    created: function created() {
        var _this = this;

        axios.get(global.websiteSettings.extra_info.api_endpoint + 'api/payment/group/1').then(function (res) {
            _this.packages = res.data.packages;
            _this.loading = false;
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/payment/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/payment/index.vue
// module chunks = 14